module.exports = __webpack_public_path__ + "static/waves-8e1c54cedfc583a086c7122d8003785a.mp4";